(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.optileanCartGrouping = factory();
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function property(item, names) {
    var p = item.properties || {};
    var pairs = Array.isArray(p) ? p : Object.entries(p).map(function (entry) { return { name: entry[0], value: entry[1] }; });
    var match = pairs.find(function (entry) { return names.includes(String(entry.name || '').replace(/^_/, '').toLowerCase()); });
    return match ? String(match.value || '').trim() : '';
  }
  function metadata(item) {
    var role = item.groupRole || property(item, ['sbc_group_role']);
    var accessory = property(item, ['sbc_finalize_accessory']);
    var title = String(item.title || '').toLowerCase();
    if (!role) {
      if (property(item, ['konfigurator']) && !accessory) role = 'board';
      else if (/edelstahlhalter/.test(title + ' ' + property(item, ['zusatzartikel']).toLowerCase())) role = 'holder';
      else if (!accessory && (item.designId || property(item, ['design_id', 'design-id']))) role = 'board';
      else role = 'product';
    }
    return {
      role: role,
      groupId: item.groupId || property(item, ['sbc_group_id']),
      cartId: item.cartId || property(item, ['cart_id']),
      source: item.sourceDraftId || property(item, ['sbc_source_draft']),
      design: item.designId || property(item, ['design_id', 'design-id']),
      name: item.draftName || property(item, ['entwurf', 'entwurfsname'])
    };
  }
  function groups(items, options) {
    if (options && options.preserveOrder === true) return items.length ? [{key: "manual", name: "", other: true, items: items.slice()}] : [];
    var result = [], others = [], metas = new Map();
    items.forEach(function (item, index) {
      var m = metadata(item); metas.set(item, m);
      if (m.role !== 'board') return;
      var key = m.groupId || m.cartId || m.source || m.design || 'row-' + index;
      var group = result.find(function (entry) { return entry.key === key; });
      if (!group) { group = { key: key, name: m.name, board: m, items: [] }; result.push(group); }
      group.items.push(item);
    });
    items.forEach(function (item) {
      var m = metas.get(item);
      if (m.role === 'board') return;
      var candidates = [];
      for (var field of ['groupId', 'cartId', 'source', 'design', 'name']) {
        if (!m[field]) continue;
        candidates = result.filter(function (entry) { return entry.board[field] === m[field]; });
        if (candidates.length) break;
      }
      if (candidates.length === 1) candidates[0].items.push(item);
      else others.push(item);
    });
    result.forEach(function (group) {
      group.items.sort(function (a, b) { return ['board', 'product', 'holder'].indexOf(metas.get(a).role) - ['board', 'product', 'holder'].indexOf(metas.get(b).role); });
    });
    if (others.length) result.push({ key: 'other', name: '', other: true, items: others });
    return result;
  }
  return { groups: groups, metadata: metadata };
});
